import { isArray, isNumber, isObject, isString } from "@hopper-ui/components";
import type { ProtectRecentlyViewedEntry } from "./registerProtectSearchProvider.tsx";

const RECENT_ITEMS_PER_PROVIDER = 5;

const STORAGE_VERSION = 2;

export interface StoredRecentlyViewed {
    version: number;
    entries: ProtectRecentlyViewedEntry[];
}

export function getRecentlyViewedStorageKey(workspaceId: string) {
    return `sg-protect:recently-viewed:${workspaceId}`;
}

function isRecentlyViewedEntry(value: unknown): value is ProtectRecentlyViewedEntry {
    if (!isObject(value) || !isString(value.providerId) || value.providerId.length === 0) {
        return false;
    }

    if (!isString(value.id) || value.id.length === 0) {
        return false;
    }

    return isString(value.displayName) && isNumber(value.viewedAt);
}

export function parseRecentlyViewed(value: unknown): ProtectRecentlyViewedEntry[] {
    if (!isObject(value) || value.version !== STORAGE_VERSION || !isArray(value.entries)) {
        return [];
    }

    return value.entries.filter(isRecentlyViewedEntry);
}

export function addRecentlyViewed(
    entries: ProtectRecentlyViewedEntry[],
    entry: ProtectRecentlyViewedEntry
): StoredRecentlyViewed {
    const candidates = [
        entry,
        ...entries.filter(other => other.providerId !== entry.providerId || other.id !== entry.id)
    ];

    const providerIds = [...new Set(candidates.map(candidate => candidate.providerId))];

    return {
        version: STORAGE_VERSION,
        entries: providerIds.flatMap(providerId =>
            candidates.filter(candidate => candidate.providerId === providerId).slice(0, RECENT_ITEMS_PER_PROVIDER)
        )
    };
}
